import {
  Component,
  OnInit,
  NgZone
} from '@angular/core';
import { MainPageService } from './../../../main-page.service';
import { Subject } from 'rxjs';
import { FormBuilder, FormControl, Validators, FormGroup } from '@angular/forms';
import { PiperingBossThreadedRodModel } from '../../../../models/parts/pipering-boss-threade-rod.model';

@Component({
  selector: 'app-pipering-bosses-managment',
  template: `<div *ngIf="piperingBossData !== undefined && piperingBossData !== null">
    <div class="row" style="padding-left: 12px;">
        <b>Pipe:</b> &nbsp;{{piperingBossData.name}}</div>
    <button type="button" class="btn btn-danger red-button" (click)="returnHandler()">Return</button>
    <button type="submit" class="btn btn-primary save-button" [disabled]="ctrl.invalid" (click)="save()">Save</button>
    <div class="row">

        <div class="col-6" style="line-height: 30px; padding-top: 30px;">
            <div class="display-flex">
                <div class="col-3">Name:
                </div>
                <input type="text" class="col-4" [(ngModel)]="piperingBossData.name" #ctrl="ngModel" required>
                <br>
            </div>
            <div class="display-flex">
                <div class="col-3">Claw:
                </div>
                <input type="number" class="col-4" [(ngModel)]="piperingBossData.claw">
            </div>
            <div class="display-flex">
                <div class="col-3">Id double connected:
                </div>
                <input type="checkbox" [(ngModel)]="piperingBossData.isDoubleConnected">
            </div>
        </div>
    </div>
    <div class="col-4">
        <kendo-grid style="border: none" [data]="piperingBossThreadedRodsGridData" (add)="addHandlerForThreadedRodData($event)" (save)="saveHandlerForThreadedRodData($event)"
            (cancel)="cancelHandlerForThreadedRodData($event)" (edit)="editHandlerForThreadedRodData($event)" (remove)="removeHandler($event)">
            <ng-template kendoGridToolbarTemplate>
                <div class="display-flex">
                    <button kendoGridAddCommand [disabled]="!canAddRowToThreadedRodsGrid" class="btn add-button light-steel-shadow" style="position: absolute; right: 15px;"
                        type="button" title="add">
                        <i class="fa fa-plus" click></i> Add</button>
                </div>
            </ng-template>
            <kendo-grid-column field="threadedRodName" title="Threaded rod (section)" width="120">
                <ng-template kendoGridEditTemplate let-dataItem="dataItem">
                    <!-- <input [(ngModel)]="dataItem.ProductName" kendoGridFocusable name="ProductName" class="k-textbox" required/> -->
                    <select #threadedRod style="width:70px;" name="threadedRodSelect" [(ngModel)]="dataItem.threadedRodId" required>
                        <option *ngFor="let threadedRod of threadedRodsData" [(value)]="threadedRod.id">{{threadedRod.name}}</option>
                    </select>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="depth" editor="editNumber" title="Depth [mm]" width="70">
            </kendo-grid-column>
            <kendo-grid-column title="" width="30">
                <ng-template kendoGridCellTemplate>
                    <div class="display-flex">
                        <!--MAGIC DO NOT TOUCH DISABLE FUNCTION-->
                        <button kendoGridEditCommand [disabled]="!canAddRowToThreadedRodsGrid" class="attributesBtn" title="Edit">
                            <i class="material-icons">&#xE3C9;</i>
                        </button>
                        <button kendoGridRemoveCommand [disabled]="!canAddRowToThreadedRodsGrid" class="attributesBtn btn-remove" data-toggle="modal" data-target="#confirmationModal"
                            title="Remove">
                            <i class="material-icons">&#xE5CD;</i>
                        </button>
                        <button kendoGridSaveCommand class="attributesBtn" title="Save">
                            <i class="material-icons">&#xE876;</i>
                        </button>
                        <button kendoGridCancelCommand class="attributesBtn" title="Cancel">
                            <i class="material-icons">&#xE5C9;</i>
                        </button>
                    </div>
                </ng-template>
            </kendo-grid-column>
        </kendo-grid>
    </div>
</div>

<!-- Delete Modal -->
<div class="modal" id="confirmationModal">
    <div class="modal-dialog">
        <div class="modal-content">

            <!-- Modal Header -->
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>

            <!-- Modal body -->
            <div class="modal-body">
                <span class="modal-label">Do you want to delete this Pipe Size?</span>
            </div>

            <!-- Modal footer -->
            <div class="modal-footer">
                <button type="button" class="btn btn-danger red-button" data-dismiss="modal">Cancel</button>
                <button type="submit" class="btn btn-primary save-button" data-dismiss="modal" (click)="removeSize()">Delete</button>
            </div>
        </div>
    </div>
</div>`,
  styles: [`.regularObjectBorder{border-width:1px;border-style:solid}.justTopBorder{border-bottom:0;border-left:0;border-right:0}.justRightBorder{border-bottom:0;border-left:0;border-top:0}.justBottomBorder{border-right:0;border-left:0;border-top:0}#tabContent{font-size:11px;border-color:#dddd}.modal-label{width:168px}hr{margin-top:0}#variantsGrid{margin-left:17px;border-color:#dddd}.delete-button{height:23px;width:23px;margin-left:3px;background-color:#d0021b;color:#fff;font-size:12px;box-shadow:0 2px 10px 0 rgba(0,0,0,.06);font-family:Roboto,sans-serif;text-transform:uppercase;outline:0;border:none;border-radius:2px;cursor:pointer}.configure-button{height:23px;margin-left:3px;background-color:#4a8bb7;color:#fff;font-size:12px;padding:3px 14px;font-weight:300;letter-spacing:1.1px;box-shadow:0 2px 10px 0 rgba(0,0,0,.06);font-family:Roboto,sans-serif;text-transform:uppercase;outline:0;border:none;margin-bottom:6px;border-radius:2px;cursor:pointer}.configure-button:disabled{background-color:#999;cursor:default}.step-file{font-size:14px;text-align:center;margin-bottom:10px;font-weight:700}#stpFileDiv{margin-left:auto;margin-right:auto}#variantsTabGrid{border:0;margin-top:26px;border-top:1px solid #ddd}.extra-padding-top{padding-top:10px}.mat-header-cell{font-weight:700}.variantBtn{background-color:#ddd;border:none;padding:6px 18px;outline:0;color:#534f53;cursor:pointer}.variants-header{margin:28px 0 5px;display:flex;justify-content:space-between}.table-label{font-size:16px}.tableCurrentVariant{font-size:14px;border-color:#708090}.borderGray{border-color:#a9a9a9}.borderGray:last-child{border-right:none}.mat-header-row{border-color:#dddd}.highlighted{background-color:#fff!important}.display-flex{display:flex;align-items:center;margin-bottom:10px}.save-button{margin-right:10px}`]
})

export class PiperingBossesManagementComponent implements OnInit {
  public piperingBossData: any;
  public isPiperingBossNew: boolean = false;
  public stateSubject: Subject<any> = new Subject();
  public piperingBossThreadedRodsGridData: PiperingBossThreadedRodModel[];
  public editedThreadedRodData: PiperingBossThreadedRodModel;
  public canAddRowToThreadedRodsGrid = true;
  private threadedRodsOpenedGridRows: number = 0;
  public isThreadedRodsGridInChangeMode = false;
  public currentOpenRow: number;
  public formGroup: FormGroup;
  public rowNumber: number;
  private removeData: PiperingBossThreadedRodModel;
  public threadedRodsData: any[] = [];

  constructor(private mainPageService: MainPageService, private formBuilder: FormBuilder) { }

  public ngOnInit(): void {
    this.piperingBossThreadedRodsGridData = [];
    this.mainPageService.deletePiperingBossThreadedRodSubject.subscribe((value) => {
      this.piperingBossThreadedRodsGridData = this.piperingBossThreadedRodsGridData.filter(x => x._id !== value);
    });
  }

  loadData(): void {
    this.mainPageService.loadPiperingBossThreadedRods(this.piperingBossData.id).subscribe((response) => {
      this.piperingBossThreadedRodsGridData = response;
    });
    this.mainPageService.loadAllThreadedRods().subscribe((response) => {
      this.threadedRodsData = response;
    })
  }

  public showManagmentPage(sender, isNew?) {
    this.piperingBossData = sender;
    if (isNew) {
      this.isPiperingBossNew = isNew;
    }
    this.loadData();
  }

  save(): void {
    this.mainPageService.updatePiperingBossInDb(JSON.stringify(this.piperingBossData)).subscribe(() => { });
    if (this.isPiperingBossNew) {
      this.isPiperingBossNew = false;
    }
  }

  returnHandler() {
    if (this.isPiperingBossNew) {
      this.mainPageService.removePiperingBoss(this.piperingBossData._id).subscribe(() => { });
      this.mainPageService.deletePipeSubject.next(this.piperingBossData._id);
      this.piperingBossData = null;
    }
    this.stateSubject.next(this.piperingBossData);
    this.piperingBossData = null;
  }

  public editHandlerForThreadedRodData({ sender, rowIndex }) {
    this.canAddRowToThreadedRodsGrid = false;

    this.threadedRodsOpenedGridRows++;
    this.isThreadedRodsGridInChangeMode = true;
    this.currentOpenRow = rowIndex;
    this.formGroup = this.createFormGroupForThreadedRodData(this.piperingBossThreadedRodsGridData[rowIndex]);
    sender.editRow(rowIndex, this.formGroup);
  }

  public cancelHandlerForThreadedRodData({ sender, rowIndex }) {
    if (this.isThreadedRodsGridInChangeMode) {
      this.threadedRodsOpenedGridRows--;
      sender.closeRow(rowIndex);
      if (this.threadedRodsOpenedGridRows === 0) {
        this.isThreadedRodsGridInChangeMode = false;
      }
      this.canAddRowToThreadedRodsGrid = true;
    } else {
      this.threadedRodsOpenedGridRows--;
      this.piperingBossThreadedRodsGridData = this.piperingBossThreadedRodsGridData.filter(
        item => item !== this.piperingBossThreadedRodsGridData[rowIndex]
      );
      sender.closeRow(rowIndex);
      this.canAddRowToThreadedRodsGrid = true;
    }

  }

  public saveHandlerForThreadedRodData({ sender, formGroup, rowIndex }) {
    this.rowNumber = rowIndex;
    if (this.isThreadedRodsGridInChangeMode) {
      if (this.formGroup.valid
      ) {
        this.threadedRodsOpenedGridRows--;

        this.overwriteDataInGrid(rowIndex, formGroup);
        sender.closeRow(rowIndex);
        this.canAddRowToThreadedRodsGrid = true;
        if (this.threadedRodsOpenedGridRows === 0) {
          this.isThreadedRodsGridInChangeMode = false;
        }
        this.editedThreadedRodData = this.piperingBossThreadedRodsGridData[rowIndex];
        this.saveEditedThreadedRod();
      }
    } else {
      if (this.formGroup.valid
      ) {
        this.threadedRodsOpenedGridRows--;


        this.overwriteDataInGrid(rowIndex, formGroup);
        sender.closeRow(rowIndex);
        this.canAddRowToThreadedRodsGrid = true;
        if (this.threadedRodsOpenedGridRows === 0) {
          this.isThreadedRodsGridInChangeMode = false;
        }
        this.editedThreadedRodData = this.piperingBossThreadedRodsGridData[rowIndex];
        this.saveNewThreadedRod();
      }
    }
  }

  public addHandlerForThreadedRodData({ sender }) {
    this.threadedRodsOpenedGridRows++;
    this.piperingBossThreadedRodsGridData.push(new PiperingBossThreadedRodModel());
    this.piperingBossThreadedRodsGridData[this.piperingBossThreadedRodsGridData.length - 1].piperingBossId = this.piperingBossData.id;
    this.canAddRowToThreadedRodsGrid = false;
    this.currentOpenRow = this.piperingBossThreadedRodsGridData.length - 1;
    sender.editRow(
      this.piperingBossThreadedRodsGridData.length - 1,
      this.formGroup = this.createFormGroupForThreadedRodData(
        this.piperingBossThreadedRodsGridData[this.piperingBossThreadedRodsGridData.length - 1]
      )
    );
  }

  public removeHandler({ dataItem }) {
    this.removeData = dataItem;
  }

  public createFormGroupForThreadedRodData(dataItem: PiperingBossThreadedRodModel): FormGroup {
    return this.formBuilder.group({
      _id: dataItem._id,
      id: dataItem.id,
      piperingBossId: dataItem.piperingBossId,
      threadedRodId: dataItem.threadedRodId,
      depth: new FormControl(dataItem.depth, Validators.compose([
        Validators.pattern('^\\d+(?:\\.\\d{1,1})?$')]))
    });
  }

  overwriteDataInGrid(rowIndex, formGroup) {
    // this.piperingBossThreadedRodsGridData[rowIndex].threadedRodId = formGroup.value.threadedRodId;
    this.piperingBossThreadedRodsGridData[rowIndex].threadedRodName = 
      this.threadedRodsData.find(x => x.id == this.piperingBossThreadedRodsGridData[rowIndex].threadedRodId).name;
    this.piperingBossThreadedRodsGridData[rowIndex].depth = formGroup.value.depth;
  }

  saveNewThreadedRod() {
    console.log(this.editedThreadedRodData);
    this.mainPageService.addNewPiperingBossThreadedRodIntoDb(
      JSON.stringify(this.piperingBossThreadedRodsGridData[this.rowNumber])).subscribe((response) => {
        this.editedThreadedRodData._id = response._id;
        this.editedThreadedRodData.id = response.id;
        this.piperingBossThreadedRodsGridData[this.rowNumber] = this.editedThreadedRodData;
      });
  }

  saveEditedThreadedRod() {
    console.log(this.piperingBossThreadedRodsGridData[this.rowNumber]);
    this.mainPageService.updatePiperingBossThreadedRodInDb(JSON.stringify(this.editedThreadedRodData)).subscribe(() => { });
  }

  public removeSize() {
    let index;
    for (let i = 0; i < this.piperingBossThreadedRodsGridData.length; i++) {
      if (this.piperingBossThreadedRodsGridData[i]._id === this.removeData._id) {
        index = i;
      }
    }
    this.deleteThreadedRod(this.piperingBossThreadedRodsGridData[index]);
  }

  deleteThreadedRod(threadedRod) {
    this.mainPageService.removePipeSize(threadedRod._id).subscribe(() => { }, () => { });
    this.mainPageService.deletePiperingBossThreadedRodSubject.next(threadedRod._id);
  }
}
